import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Http from "../../../../commons/utils/Http";
import ButtonAction from "../../../../commons/components/buttonAction";
import CardContainer from "../../../../commons/components/cardContainer"

import {
    accessManagementSetEditApplication,
    accessManagementSetFilterApplication
} from '../../../../store/actions/accessManagementActions';

import {
    ListCard,
    ButtonsCard,
    SaibaMaisButton
} from './cardApplicationsStyles';

function CardApplications(props) {
    const dispatch = useDispatch();
    const userId = useSelector(state => state.userLogin.userData.id);
    const { screens } = useSelector(state => state.userLogin);

    const [permissions] = useState([]);
    const [applicationsData, setApplicationsData] = useState([])
    
    const { selectedPartner } = useSelector((state) => state.accessManagement);
    
    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/users") {
                    screen.functions.map(_function => {
                        if (!permissions.find(permission => permission.function_id == _function.function_id)) {
                            permissions.push(_function);
                        }
                    })
                }
            });
        }
    }, [screens]);
    
    useEffect( () => {
        if(userId) {
            getApplications(); 
        }
    }, [userId]);
    
    function getApplications() {
        Http.get(`applications/get-total-user-by-partner?id=${selectedPartner.partner_id}`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    if(responseData.data) {
                        setApplicationsData(responseData.data);
                    } else {
                        setApplicationsData([]);
                    }
                }
            }).catch(err => {
                setApplicationsData([]);
            })
    }

    function handleEditPartner(application) {
        dispatch(accessManagementSetFilterApplication({key: application.application_id, value: application.application_id, children: application.application_name}));
        dispatch(accessManagementSetEditApplication(true));
    }

    const renderCards = () => (
        <ListCard>
            { applicationsData.map((application, key) => {
                return (
                    <CardContainer key={key} style={{ marginRight: 16, minWidth: 450 }}>
                        <strong className="application-name">{application.application_name || "Nome não encontrado"}</strong>

                        <p className="application-details">
                            <strong className="application-description">Equipe:</strong> <span className="application-description-val">{application.total_user ? application.total_user + " pessoas" : "Número da equipe não encontrado"}</span>
                        </p>

                        <ButtonsCard>
                            <ButtonAction type="edit" text="Editar Empresa" borderRadius="50" callback={() => handleEditPartner(application)} />
                            { application.link ? <SaibaMaisButton href={application.link} target="_blank" >Saiba mais</SaibaMaisButton> : null }
                        </ButtonsCard>
                    </CardContainer>
                )
            })
            }
        </ListCard>
    );

    return (
        renderCards()
    )
}

export default CardApplications;
